import jquery from 'jquery';

export const hideLoadingAnimation = (): void => {
  const loadingContainer = jquery('#loading-screen');
  // removing the 'visible' class is enough to stop the loading-animation
  // it has a code which checks that class on each frame update and stop the
  // loop if the 'visible' class was removed
  loadingContainer.removeClass('visible');
};
